import { Injectable } from "@angular/core";
import { Platform } from "ionic-angular";

/*
  Generated class for the MobileUtilsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MobileUtilsProvider {
  //Flag to initiate prepared mode data download
  mobileDataDownloadedAtKey: string = "mobileDataDownloadedAt";
  offlineAuthKey: string = "offlineAuth";

  constructor(public platform: Platform) {}

  isMobilePlatform(): boolean {
    return this.platform.is("ios") && this.platform.is("cordova");
  }

  getMobileAppNavigation(activeTab, isOnline = true): any {
    const tabs = [
      {
        label: "Careplan",
        icon: "carePlan",
        active: activeTab === "Careplan",
        url: "/carePlan/visits",
      },
    ];

    if (isOnline) {
      tabs.push(
        {
          label: "Careteam",
          icon: "careTeam",
          active: activeTab === "Careteam",
          url: "/careTeams",
        },
        {
          label: "Documents",
          icon: "documents",
          active: activeTab === "Documents",
          url: "/docManagement/docManagement",
        }
      );
    }

    return tabs;
  }

  checkIfMobile(): boolean {
    return (
      this.platform.is("mobile") &&
      !this.platform.is("ipad") &&
      !this.platform.is("tablet")
    );
  }

  isIOSDevice(): boolean {
    return this.platform.is("ios");
  }
}



// WEBPACK FOOTER //
// ./src/providers/mobile-utils/mobile-utils.ts